import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Box,
  Grid,
  Typography,
  IconButton,
  Button,
  Divider,
  TextField,
  Autocomplete,
  Tooltip,
  Chip,
  Alert,
  Card,
  CardContent,
  Fade,
  Zoom
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import LockIcon from "@mui/icons-material/Lock";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import ScienceIcon from "@mui/icons-material/Science";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import TopicIcon from '@mui/icons-material/Topic';
import EditNoteIcon from '@mui/icons-material/EditNote';
import axios from "axios";
import { saveAdmissionInfoRound ,loadWardRoundsdb } from "../BaseURL";
import VitalsHistoryDialogAdmission from "./VitalsHistoryDialogAdmission";
import LabHistoryDialogAdmission from "./LabHistoryDialogAdmission";
import ScanHistoryDialogAdmission from "./ScanHistoryDialogAdmission";
import MedicalHistoryDialogAdmission from "./MedicationHistoryDialogAdmission";
import RequsetLabDialog from "./RequsetLabDialog";

import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import RequestScanDialog from "./RequestScanDialog";
import MedicationRequestDialog from "./MedicationRequestDialog";
import RequestOtherServiceDialog from "./RequestOtherServiceDialog";
import NurseNotesDialog from "./NurseNotesDialog";
import MedicationAdministrationSheet from "../Wards/MedicationAdministrationSheet";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ErrorMessage } from "../Message";
const WardRoundsDialog = ({
  open,
  onClose,
  fields,
  utils,
  patient,
  diagnosisOptions,
  selectedDiagnoses,
  setSelectedDiagnoses,
  saveOrUpdateDiagnosis,
  procedureOptions,
  selectedProcedures,
  setSelectedProcedures,
  saveOrUpdateProcedure
}) => {
  const { startDate } = fields;
  const { suggestionsData, setHasEdited } = utils;

  const [currentUser, setCurrentUser] = useState('');
  const [canEdit, setCanEdit] = useState(true);
  const [selectedDocName, setSelectedDocName] = useState('');
  const [medDialogOpen, setMedDialogOpen] = useState(false);
  const [serviceDialogOpen, setServiceDialogOpen] = useState(false);
  const [nurseNotesOpen, setNurseNotesOpen] = useState(false);
  const [medSheetOpen, setMedSheetOpen]     = useState(false);
  

  useEffect(() => {
    const savedUserInfo = localStorage.getItem('userInfo');
    if (savedUserInfo) {
      const userInfo = JSON.parse(savedUserInfo);
      const userName = userInfo.name || '';
      setCurrentUser(userName);
    }

  }, []);

 useEffect(() => {
    if (!open) {
      // Clear all data when dialog closes
      setSelectedDate(null);
      setComplaint('');
      setExam('');
      setOther('');
      settreatmentPlan('');
      setSurgical_Notes('');
      setNewcomplaint('');
      setnewtreatmentPlan('');
      setexam('');
      setother('');
      setsurgical('');
      setSelectedDocName('');
      setCanEdit(true);
      setWardRoundsData([]);
      setOpenDates({});
    }
  }, [open]);


  useEffect(() => {
  if (open && patient?.id && startDate) {
    loadWardRoundsData();
  }
}, [open, patient?.id, startDate]);


  const [selectedDate, setSelectedDate] = useState(null);
  const [complaint, setComplaint] = useState('');
  const [exam, setExam] = useState('');
  const [other, setOther] = useState('');
  const [treatmentPlan, settreatmentPlan] = useState('');
  const [Surgical_Notes, setSurgical_Notes] = useState('');

  // Add More Text Dialog States
  const [dialogOpen, setDialogOpen] = useState({ open: false, field: "" });
  const [dialogText, setDialogText] = useState("");

  const [Newcomplaint, setNewcomplaint] = useState('')
  const [newtreatmentPlan, setnewtreatmentPlan] = useState('')
  const [newexam, setexam] = useState('')
  const [newother, setother] = useState('')
  const [newsurgical, setsurgical] = useState('')

const [roundState, setRoundState] = useState('');
const [roundDate, setRoundDate] = useState('');
const [roundTime, setRoundTime] = useState('');
const [scanOpen, setScanOpen] = useState(false);



const handleDialogOpen = (field) => {
  let currentText = "";
  if (field === "complaint") currentText = Newcomplaint;
  if (field === "exam") currentText = newexam;
  if (field === "other") currentText = newother;
  if (field === "treatmentPlan") currentText = newtreatmentPlan;
  if (field === "surgical") currentText = Surgical_Notes;

  setDialogText(currentText);
  
  // Set current date and time
 const now = new Date();
const year = now.getFullYear();
const month = String(now.getMonth() + 1).padStart(2, '0');
const day = String(now.getDate()).padStart(2, '0');
setRoundDate(`${year}-${month}-${day}`); // This uses your local timezone
  setRoundTime(now.toTimeString().slice(0, 5)); // HH:MM
  
  // Automatically determine round state based on time
  const hour = now.getHours();
  let autoRoundState = '';
  
  if (hour >= 6 && hour < 12) {
    autoRoundState = 'Morning Round';
  } else if (hour >= 12 && hour < 18) {
    autoRoundState = 'Afternoon Round';
  } else if (hour >= 18 && hour < 24) {
    autoRoundState = 'Evening Round';
  } else {
    // After midnight (0-5 AM) - default to Evening Round
    autoRoundState = 'Evening Round';
  }
  
  setRoundState(autoRoundState);
  
  setDialogOpen({ open: true, field });
};
  const handleDialogClose = () => {
    setDialogOpen({ open: false, field: "" });
    setDialogText("");
  };

 const handleDialogSave = async () => {  // ← Made async

  if (dialogOpen.field === "complaint") setNewcomplaint(dialogText);
  if (dialogOpen.field === "treatmentPlan") setnewtreatmentPlan(dialogText);
  if (dialogOpen.field === "exam") setexam(dialogText);
  if (dialogOpen.field === "other") setother(dialogText);
  if (dialogOpen.field === "surgical") setsurgical(dialogText);

  // ✅ NEW CODE: Actually saves to backend
  try {
    await axios.post(saveAdmissionInfoRound, {
      patientId: patient?.id,
      symptoms: dialogOpen.field === "complaint" ? dialogText : Newcomplaint,
      ex_result: dialogOpen.field === "exam" ? dialogText : newexam,
      Other_doc: dialogOpen.field === "other" ? dialogText : newother,
      Surgical_Notes: dialogOpen.field === "surgical" ? dialogText : newsurgical,
      plan: dialogOpen.field === "treatmentPlan" ? dialogText : newtreatmentPlan,
      state: roundState,
      dat: roundDate,
      time: roundTime,
      doctor: currentUser,
    });

    // Reload data and auto-select the date
    await loadWardRoundsData();
    setSelectedDate(roundDate);
  } catch (error) {
    
    ErrorMessage('Failed to save data. Please try again')
    return; // Don't close if save failed
  }

  setHasEdited(true);
  setDialogText("");
  handleDialogClose();
};

 const handleDateSelect = (date, state, time) => {
  setSelectedDate(date);

  const entry = wardRoundsDataa.find(
    item => item.date === date && item.state === state && item.time === time
  );

  if (entry) {
    setComplaint(entry.complaint || "");
    setExam(entry.physicalExam || "");
    setOther(entry.otherDocumentation || "");
    settreatmentPlan(entry.plan || "");
    setSurgical_Notes(entry.surgicalNotes || "");

    setSelectedDocName(entry.doctor);

    setCanEdit(currentUser === entry.doctor);

    setHasEdited(true);
  }
};


  const fieldConfigs = [
    {
      field: "complaint",
      label: "Complaint",
      value: complaint,
      setter: setComplaint,
      buttonText: "New Complaint",
      gradient: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
      hoverGradient: "linear-gradient(135deg, #1565c0 0%, #1e88e5 100%)",
      icon: <MedicalServicesIcon />
    },
    {
      field: "exam",
      label: "Physical Examination",
      value: exam,
      setter: setExam,
      buttonText: "New Physical Exam",
      gradient: "linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)",
      hoverGradient: "linear-gradient(135deg, #1b5e20 0%, #388e3c 100%)",
      icon: <LocalHospitalIcon />
    },
    {
      field: "other",
      label: "Other Documentation",
      value: other,
      setter: setOther,
      buttonText: "New Documentation",
      gradient: "linear-gradient(135deg, #ef6c00 0%, #ffa726 100%)",
      hoverGradient: "linear-gradient(135deg, #e65100 0%, #fb8c00 100%)",
      icon: <NoteAddIcon />
    },
    {
      field: "surgical",
      label: "Surgical Notes",
      value: Surgical_Notes,
      setter: setSurgical_Notes,
      buttonText: "New Surgical Note",
      gradient: "linear-gradient(135deg, #6a1b9a 0%, #ab47bc 100%)",
      hoverGradient: "linear-gradient(135deg, #4a148c 0%, #8e24aa 100%)",
      icon: <ScienceIcon />
    },
    {
      field: "treatmentPlan",
      label: "Treatment Plan",
      value: treatmentPlan,
      setter: settreatmentPlan,
      buttonText: "New Treatment Plan",
      gradient: "linear-gradient(135deg, #c2185b 0%, #f06292 100%)",
      hoverGradient: "linear-gradient(135deg, #880e4f 0%, #d81b60 100%)",
      icon: <MedicalServicesIcon />
    }
  ];


useEffect(() => {
  if (!dialogOpen.open) return;               // Dialog must be open
  if (!roundState || !roundDate || !roundTime) return;

  const timeout = setTimeout(async () => {
    // PUT new text into the main field states
    if (dialogOpen.field === "complaint") setNewcomplaint(dialogText);
    if (dialogOpen.field === "exam") setexam(dialogText);
    if (dialogOpen.field === "other") setother(dialogText);
    if (dialogOpen.field === "surgical") setsurgical(dialogText);
    if (dialogOpen.field === "treatmentPlan") setnewtreatmentPlan(dialogText);

    // CALL BACKEND
    await axios.post(saveAdmissionInfoRound, {
      patientId: patient?.id,
      symptoms: dialogOpen.field === "complaint" ? dialogText : Newcomplaint,
      ex_result: dialogOpen.field === "exam" ? dialogText : newexam,
      Other_doc: dialogOpen.field === "other" ? dialogText : newother,
      Surgical_Notes: dialogOpen.field === "surgical" ? dialogText : newsurgical,
      plan: dialogOpen.field === "treatmentPlan" ? dialogText : newtreatmentPlan,
      state: roundState,
      dat: roundDate,
      time: roundTime,
      doctor: currentUser,
    });

    // Reload data and auto-select the date
    await loadWardRoundsData();
    setSelectedDate(roundDate);

  }, 2000);

  return () => clearTimeout(timeout);

}, [dialogText, roundState, roundDate, roundTime]);


const validateRoundEntry = () => {
  if (!roundState) {
    alert("Please select a round state (Morning, Evening, Review).");
    return false;
  }

  if (!roundDate) {
    alert("Please select a date.");
    return false;
  }

  if (!roundTime) {
    alert("Please select a time.");
    return false;
  }

  // Morning: 4am – 11:59am
  if (roundState === "Morning Round") {
    if (!(roundTime >= "04:00" && roundTime <= "11:59")) {
      alert("Morning Round must have a time between 4:00 AM and 11:59 AM.");
      return false;
    }
  }

  // Evening: 12:00pm – 7:00pm
  if (roundState === "Evening Round") {
    if (!(roundTime >= "12:00" && roundTime <= "19:00")) {
      alert("Evening Round must have a time between 12:00 PM and 7:00 PM.");
      return false;
    }
  }

  return true;
};

const [wardRoundsDataa, setWardRoundsData] = useState([]);

const loadWardRoundsData = async () => {
  if (!patient?.id) return;

  try {
    const res = await axios.get(loadWardRoundsdb, {
      params: {
        patientId: patient?.id,
        startDate: startDate   // admission date
      }
    });

    if (res.data.success) {
      setWardRoundsData(res.data.data);

    }
  } catch (error) {
    console.error("Error loading ward rounds:", error);
  }
};

let saveTimer = null;

const autoSaveLoadedEntry = (field, value) => {
  clearTimeout(saveTimer);

  saveTimer = setTimeout(async () => {

    await axios.post(saveAdmissionInfoRound, {
      patientId: patient?.id,
      symptoms: field === "complaint" ? value : complaint,
      ex_result: field === "exam" ? value : exam,
      Other_doc: field === "other" ? value : other,
      Surgical_Notes: field === "surgical" ? value : Surgical_Notes,
      plan: field === "treatmentPlan" ? value : treatmentPlan,
      state: wardRoundsDataa.find(x => x.date === selectedDate)?.state,
      dat: selectedDate,
      time: wardRoundsDataa.find(x => x.date === selectedDate)?.time,
      doctor: currentUser,
    });

    await loadWardRoundsData();

  }, 2000);
};


const groupByDate = (data) => {
  const groups = {};

  data.forEach(item => {
    if (!groups[item.date]) groups[item.date] = [];
    groups[item.date].push(item);
  });

  return groups;
};

const groupedRounds = groupByDate(wardRoundsDataa);

const [openDates, setOpenDates] = useState({});

const toggleDate = (date) => {
  setOpenDates(prev => ({ ...prev, [date]: !prev[date] }));
};

const [VitalsHistoryOpen ,setVitalsHistoryOpen]=useState(false)
const [labHistoryOpen ,setlabHistoryOpen]=useState(false)
const [ScanHistoryOpen ,setScanHistoryOpen]=useState(false)
const [openmedHis ,setopenmedHis]=useState(false)
const [labOpen, setLabOpen] = useState(false);


const historyButtons = [
    {
      label: 'Vitals',
      icon: <MonitorHeartIcon />,
      onClick: () => setVitalsHistoryOpen(true),
      color: '#e53935',
      bgColor: 'rgba(229, 57, 53, 0.08)'
    },
    {
      label: 'Labs',
      icon: <ScienceIcon />,
      onClick: () => setlabHistoryOpen(true),
      color: '#1e88e5',
      bgColor: 'rgba(30, 136, 229, 0.08)'
    },
    {
      label: 'Scan',
      icon: <LocalHospitalIcon />,
      onClick: () => setScanHistoryOpen(true),
      color: '#43a047',
      bgColor: 'rgba(67, 160, 71, 0.08)'
    },
    {
      label: 'Medications',
      icon: <MedicalServicesIcon />,
      onClick: () => setopenmedHis(true),
      color: '#fb8c00',
      bgColor: 'rgba(251, 140, 0, 0.08)'
    } ,

    {
      label: 'Medications Sheet',
      icon: <TopicIcon />,
      onClick: () => setMedSheetOpen(true),
      color: '#1A9B7F',
      bgColor: 'rgba(26,155,127,0.08)'
    },

     {
      label: 'Nurses Note',
      icon: <EditNoteIcon />,
      onClick: () => setNurseNotesOpen(true),
      color: '#1A9B7F',
      bgColor: 'rgba(26,155,127,0.08)'
    }
];

  return (
    <>
      <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth="xl" 
        fullWidth
        TransitionComponent={Fade}
        transitionDuration={300}
      >
        {/* HEADER WITH PATIENT INFO */}
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #19b934ff 0%, #19b934ff 100%)",
            color: "white",
            pb: 1,
            pt: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: 1.5,
            }}
          >
            {/* LEFT SIDE: Patient Info */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {/* PATIENT AVATAR */}
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.1) 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  color: "white",
                  border: "2px solid rgba(255,255,255,0.5)",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                }}
              >
                {patient?.name
                  ?.split(" ")
                  .map((n) => n[0])
                  .join("")
                  .toUpperCase()}
              </Box>

              {/* NAME + DETAILS */}
              <Box>
                <Typography sx={{ fontWeight: 700, fontSize: "1.3rem", letterSpacing: "0.5px" }}>
                  {patient?.name?.toUpperCase()}
                </Typography>

                <Typography sx={{ fontSize: "0.95rem", opacity: 0.95, mt: 0.5 }}>
                  ID: {patient?.id} • Age: {patient?.age} • Gender:{" "}
                  {patient?.gender?.toUpperCase()} • Tel: {patient?.phone}
                </Typography>
              </Box>
            </Box>

            {/* CLOSE BUTTON */}
            <IconButton 
              sx={{ 
                color: "white",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.15)",
                  transform: "rotate(90deg)",
                  transition: "all 0.3s ease"
                }
              }} 
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1, ml: 1 }}>
            <CalendarTodayIcon sx={{ fontSize: "1.2rem" }} />
            <Typography sx={{ fontWeight: 600, fontSize: "1.1rem" }}>
              Ward Rounds
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 3, bgcolor: "#f5f7fa" }}>
          {/* Edit Restriction Alert */}
          {!canEdit && selectedDate && (
            <Zoom in={!canEdit}>
              <Alert 
                severity="warning" 
                icon={<LockIcon />}
                sx={{ 
                  mb: 3,
                  borderRadius: 2,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                }}
              >
                <strong>View Only Mode:</strong> This entry was created by {selectedDocName}. 
                You can only edit entries you created.
              </Alert>
            </Zoom>
          )}

          <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: 12 }}>
            {/* ================= LEFT SIDE – ADMISSION DATES ================= */}
            <Grid item xs={12} md={3} size={2}>
              <Card
                sx={{
                  borderRadius: 3,
                  maxHeight: "75vh",
                  overflowY: "auto",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  scrollbarWidth: "thin",
                  "&::-webkit-scrollbar": {
                    width: "8px"
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px"
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#1976d2",
                    borderRadius: "10px",
                    "&:hover": {
                      background: "#1565c0"
                    }
                  }
                }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                    <CalendarTodayIcon color="primary" />
                    <Typography fontWeight={700} fontSize="1.1rem">Admission Dates</Typography>
                  </Box>
                  <Divider sx={{ mb: 2 }} />

                {Object.keys(groupedRounds).map((date, index) => (
                <Box key={index} sx={{ mb: 1.5 }}>

                  {/* --- MAIN DATE HEADER --- */}
                  <Paper
                    elevation={openDates[date] ? 2 : 0}
                    onClick={() => toggleDate(date)}
                    sx={{
                      p: 1.5,
                      borderRadius: 1.5,
                      cursor: "pointer",
                      background: openDates[date] ? "#1976d2" : "#f5f5f5",
                      color: openDates[date] ? "white" : "#333",
                      transition: "all 0.2s ease",
                      border: openDates[date] ? "none" : "1px solid #e0e0e0",
                      "&:hover": {
                        background: openDates[date] ? "#1565c0" : "#eeeeee"
                      },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between"
                    }}
                  >
                    <Typography fontWeight={600} fontSize="0.95rem">
                      {date}
                    </Typography>
                    {openDates[date] ? (
                      <ExpandMoreIcon sx={{ fontSize: "1.2rem" }} />
                    ) : (
                      <ChevronRightIcon sx={{ fontSize: "1.2rem" }} />
                    )}
                  </Paper>

                  {/* --- CHILD ENTRIES --- */}
                  {openDates[date] && (
                    <Box sx={{ mt: 0.5 }}>
                      {groupedRounds[date].map((item, i) => (
                        <Paper
                          key={i}
                          onClick={() => handleDateSelect(item.date, item.state, item.time)}
                          elevation={0}
                          sx={{
                            p: 1.25,
                            ml: 2,
                            mt: 0.5,
                            borderRadius: 1,
                            cursor: "pointer",
                            border: selectedDate === item.date && selectedDocName === item.doctor 
                              ? "2px solid #1976d2" 
                              : "1px solid #e0e0e0",
                            background: selectedDate === item.date && selectedDocName === item.doctor
                              ? "#e3f2fd"
                              : "white",
                            "&:hover": {
                              background: "#f5f5f5",
                              borderColor: "#1976d2"
                            },
                            transition: "all 0.2s ease"
                          }}
                        >
                          <Typography fontSize="0.875rem" fontWeight={500} color="text.primary">
                            {item.doctor}
                          </Typography>
                          <Typography fontSize="0.8rem" color="text.secondary" sx={{ mt: 0.25 }}>
                            {item.state}
                          </Typography>
                        </Paper>
                      ))}
                    </Box>
                  )}

                </Box>
              ))}
               

                  
                </CardContent>
              </Card>
            </Grid>

            {/* ================= RIGHT SIDE — ALL FIELDS ================= */}
            <Grid item xs={12} md={9} size={10}>
              <Grid container spacing={2.5} columns={{ xs: 4, sm: 8, md: 12 }}>
                
                {/* ================= TEXT FIELDS ================= */}
                {fieldConfigs.map((config) => (
                  <Grid item xs={12} md={6} size={2.4} key={config.field}>
                    <Card 
                      sx={{ 
                        height: "100%",
                        borderRadius: 3,
                        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
                          transform: "translateY(-2px)"
                        }
                      }}
                    >
                      <CardContent sx={{ p: 2.5 }}>
                        <TextField
                          label={config.label}
                          multiline
                          rows={5}
                          fullWidth
                          value={config.value}
                          onChange={(e) => {
                            if (canEdit) {
                              config.setter(e.target.value);
                              setHasEdited(true);
                              autoSaveLoadedEntry(config.field, e.target.value);
                            }
                          }}
                          placeholder={`Enter ${config.label.toLowerCase()}...`}
                          disabled={!canEdit}
                          InputProps={{
                            readOnly: !canEdit,
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 2,
                              "&:hover fieldset": {
                                borderColor: "primary.main",
                              }
                            }
                          }}
                        />

                        <Box sx={{ mt: 2 }}>
                          <Tooltip title={`Add ${config.buttonText}`}>
                            <span style={{ width: '100%' }}>
                              <Button
                                variant="contained"
                                size="small"
                                startIcon={config.icon}
                                fullWidth
                                onClick={() => handleDialogOpen(config.field)}
                                sx={{
                                  background: config.gradient,
                                  color: "white",
                                  borderRadius: 2,
                                  textTransform: "none",
                                  fontWeight: 600,
                                  py: 1,
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                  "&:hover": {
                                    background: config.hoverGradient,
                                    boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
                                    transform: "translateY(-1px)"
                                  },
                                  transition: "all 0.3s ease"
                                }}
                              >
                                {config.buttonText}
                              </Button>
                            </span>
                          </Tooltip>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}

                {/* ================= DIAGNOSIS(ES) ================= */}
               <Grid item xs={12} md={6} size={6} >
                 <Typography variant="subtitle1" gutterBottom>
                   Diagnosis(es)
                 </Typography>
               
                 <Autocomplete
                   multiple
                   options={diagnosisOptions}
                   value={selectedDiagnoses || []}
                   onChange={(event, newValue) => {
                     setSelectedDiagnoses(newValue);
                     saveOrUpdateDiagnosis(newValue); // ✅ CALL FUNCTION HERE
                   }}
                   getOptionLabel={(option) =>
                     option && option.code && option.name
                       ? `${option.name}`
                       : ""
                   }
                   filterSelectedOptions
                   isOptionEqualToValue={(option, value) => option.id === value.id}
                   filterOptions={(options, { inputValue }) => {
                     const search = inputValue.toLowerCase();
                     return options.filter(
                       (opt) =>
                         opt.name.toLowerCase().includes(search) ||
                         opt.code.toLowerCase().includes(search) ||
                         (opt.cat && opt.cat.toLowerCase().includes(search)) ||
                         (opt.core && opt.core.toString().toLowerCase().includes(search))
                     );
                   }}
                   renderInput={(params) => (
                     <TextField {...params} placeholder="Search by code or diagnosis name..." />
                   )}
                   renderOption={(props, option) => (
                     <li {...props} key={option.id}>
                       <Box>
                         <Typography variant="body2" color="bold">
                           {option.name}
                         </Typography>
                       </Box>
                     </li>
                   )}
                   renderTags={(value, getTagProps) =>
                     value.map((option, index) => (
                       <Chip
                         key={option.id}
                         label= {option.name}
                         {...getTagProps({ index })}
                         size="small"
                       />
                     ))
                   }
                 />
               </Grid>

                {/* ================= PROCEDURE(S) ================= */}
                <Grid item xs={12} md={6} size={6}>
                  <Typography variant="subtitle1" gutterBottom>
                    Procedure(s)
                  </Typography>
                
                  <Autocomplete
                    multiple
                    options={procedureOptions}
                    value={selectedProcedures || []}
                    onChange={(event, newValue) => {
                      setSelectedProcedures(newValue);
                      saveOrUpdateProcedure(newValue); // ✅ SAVE ON CHANGE
                    }}
                    getOptionLabel={(option) =>
                      option && option.name ? `${option.name}` : ""
                    }
                    filterSelectedOptions
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    filterOptions={(options, { inputValue }) => {
                      const search = inputValue.toLowerCase();
                      return options.filter((opt) =>
                        opt.name && opt.name.toLowerCase().includes(search)
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search by procedure code or name..."
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        <Box>
                          <Typography variant="body2" color="bold">
                            {option.name}
                          </Typography>
                        </Box>
                      </li>
                    )}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          key={option.id}
                          label={option.name}
                          {...getTagProps({ index })}
                          size="small"
                        />
                      ))
                    }
                  />
                </Grid>
                        
                {/* ================= PATIENT RESULTS BUTTONS ================= */}
                <Grid item xs={12} size={12}>
                  <Card 
                    sx={{ 
                      borderRadius: 2, 
                      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                      overflow: 'hidden',
                      border: '1px solid rgba(0,0,0,0.08)',
                      bgcolor: '#fafafa'
                    }}
                  >
                    <Box 
                      sx={{ 
                        background: '#ffffff',
                        borderBottom: '1px solid rgba(0,0,0,0.08)',
                        p: 2,
                        color: '#37474f'
                      }}
                    >
                      <Typography variant="h6" fontWeight={500} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <LocalHospitalIcon sx={{ color: '#546e7a' }} />
                        Admission History / Results 
                      </Typography>
                    </Box>

                    <CardContent sx={{ p: 3, bgcolor: '#ffffff' }}>
                      <Box 
                        sx={{ 
                          display: 'grid',
                          gridTemplateColumns: {
                            xs: '1fr',
                            sm: 'repeat(2, 1fr)',
                            md: 'repeat(4, 1fr)'
                          },
                          gap: 2
                        }}
                      >
                        {historyButtons.map((btn, index) => (
                          <Button
                            key={index}
                            variant="outlined"
                            onClick={btn.onClick}
                            startIcon={btn.icon}
                            sx={{
                              background: '#ffffff',
                              color: '#546e7a',
                              borderRadius: 1,
                              textTransform: 'none',
                              fontWeight: 300,
                              px: 1,
                              py: 1,
                              border: '1px solid #e0e0e0',
                              boxShadow: 'none',
                              '&:hover': {
                                background: '#f5f5f5',
                                borderColor: '#9e9e9e',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                              },
                              transition: 'all 0.2s ease',
                              '& .MuiButton-startIcon': {
                               
                                color: '#78909c'
                              }
                            }}
                          >
                            {btn.label}
                          </Button>
                        ))}
                        
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* ================= REQUEST BUTTON GROUP ================= */}
              <Grid item xs={12} size={12}>
                <Card 
                  sx={{ 
                    borderRadius: 2, 
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    overflow: 'hidden',
                    border: '1px solid rgba(0,0,0,0.08)',
                    bgcolor: '#fafafa'
                  }}
                >
                  <Box 
                    sx={{ 
                      background: '#ffffff',
                      borderBottom: '1px solid rgba(0,0,0,0.08)',
                      p: 2,
                      color: '#37474f'
                    }}
                  >
                    <Typography variant="h6" fontWeight={500} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <MedicalServicesIcon sx={{ color: '#546e7a' }} />
                      Request Services / Medication
                    </Typography>
                  </Box>

                  <CardContent sx={{ p: 3, bgcolor: '#ffffff' }}>
                    <Box 
                      sx={{ 
                        display: 'grid',
                        gridTemplateColumns: {
                          xs: '1fr',
                          sm: 'repeat(2, 1fr)',
                          md: 'repeat(4, 1fr)'
                        },
                        gap: 2
                      }}
                    >
                      <Button
                        variant="outlined"
                        onClick={() => setLabOpen(true)}
                        startIcon={<ScienceIcon />}
                        sx={{
                          background: '#ffffff',
                          color: '#546e7a',
                          borderRadius: 1,
                          textTransform: 'none',
                          fontWeight: 300,
                          px: 1,
                          py: 1,
                          border: '1px solid #e0e0e0',
                          boxShadow: 'none',
                          '&:hover': {
                            background: '#f5f5f5',
                            borderColor: '#9e9e9e',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                          },
                          transition: 'all 0.2s ease',
                          '& .MuiButton-startIcon': {
                            marginRight: 1,
                            color: '#78909c'
                          }
                        }}
                      >
                        Labs
                      </Button>

                      <Button
                        variant="outlined"
                        onClick={() => setScanOpen(true)}
                        startIcon={<LocalHospitalIcon />}
                        sx={{
                          background: '#ffffff',
                          color: '#546e7a',
                          borderRadius: 1.5,
                          textTransform: 'none',
                          fontWeight: 500,
                          px: 2.5,
                          py: 1.5,
                          border: '1.5px solid #e0e0e0',
                          boxShadow: 'none',
                          '&:hover': {
                            background: '#f5f5f5',
                            borderColor: '#9e9e9e',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                          },
                          transition: 'all 0.2s ease',
                          '& .MuiButton-startIcon': {
                            marginRight: 1,
                            color: '#78909c'
                          }
                        }}
                      >
                        Scan
                      </Button>

                      <Button
                        variant="outlined"
                        onClick={() => setMedDialogOpen(true)}
                        startIcon={<MedicalServicesIcon />}
                        sx={{
                          background: '#ffffff',
                          color: '#546e7a',
                          borderRadius: 1.5,
                          textTransform: 'none',
                          fontWeight: 500,
                          px: 2.5,
                          py: 1.5,
                          border: '1.5px solid #e0e0e0',
                          boxShadow: 'none',
                          '&:hover': {
                            background: '#f5f5f5',
                            borderColor: '#9e9e9e',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                          },
                          transition: 'all 0.2s ease',
                          '& .MuiButton-startIcon': {
                            marginRight: 1,
                            color: '#78909c'
                          }
                        }}
                      >
                        Medication
                      </Button>

                      <Button
                        variant="outlined"
                        onClick={() => setServiceDialogOpen(true)}
                        startIcon={<NoteAddIcon />}
                        sx={{
                          background: '#ffffff',
                          color: '#546e7a',
                          borderRadius: 1.5,
                          textTransform: 'none',
                          fontWeight: 500,
                          px: 2.5,
                          py: 1.5,
                          border: '1.5px solid #e0e0e0',
                          boxShadow: 'none',
                          '&:hover': {
                            background: '#f5f5f5',
                            borderColor: '#9e9e9e',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                          },
                          transition: 'all 0.2s ease',
                          '& .MuiButton-startIcon': {
                            marginRight: 1,
                            color: '#78909c'
                          }
                        }}
                      >
                        Other Services
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

            </Grid>
            </Grid>

          </Grid>
        </DialogContent>

        <DialogActions sx={{ p: 2.5, bgcolor: "#f5f7fa", borderTop: "1px solid #e0e0e0" }}>
          <Button 
            onClick={onClose} 
            variant="contained" 
            color="error"
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              px: 4,
              py: 1,
              boxShadow: "0 4px 12px rgba(211, 47, 47, 0.3)",
              "&:hover": {
                boxShadow: "0 6px 16px rgba(211, 47, 47, 0.4)",
                transform: "translateY(-1px)"
              },
              transition: "all 0.3s ease"
            }}
          >
            Close
          </Button>
        </DialogActions>

      </Dialog>

      {/* ================= ADD MORE TEXT DIALOG ================= */}
      <Dialog
        open={dialogOpen.open}
        fullWidth
        maxWidth="md"
        TransitionComponent={Zoom}
      >
        <DialogTitle 
          sx={{ 
            background: "linear-gradient(135deg, #14aa41ff 0%, #1ac971ff 100%)",
            color: "white",
            fontWeight: 700
          }}
        >
          Add {dialogOpen.field}
        </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        <Grid container spacing={2.5} columns={{ xs: 4, sm: 8, md: 12 }}>
          
          {/* 🔵 ROUND STATE DROPDOWN */}
          <Grid item xs={12} md={6} size={3}>
            <Box>
              <Typography fontWeight={600} sx={{ mb: 1 }}>
                Select Round State
              </Typography>
              <Autocomplete
                options={["Morning Round", "Afternoon Round", "Evening Round", "Review Round"]}
                value={roundState}
                onChange={(e, val) => setRoundState(val)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Round State"
                    sx={{
                      "& .MuiOutlinedInput-root": { borderRadius: 2 },
                    }}
                  />
                )}
              />
            </Box>
          </Grid>

          {/* 🟣 CURRENT DOCTOR (DISABLED FIELD) */}
          <Grid item xs={12} md={6} size={3}>
            <Box>
              <Typography fontWeight={600} sx={{ mb: 1 }}>
                Doctor
              </Typography>
              <TextField
                value={currentUser}
                disabled
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    backgroundColor: "#f5f5f5",
                  }
                }}
              />
            </Box>
          </Grid>

          {/* 📅 DATE PICKER */}
          <Grid item xs={12} md={6} size={3}>
            <Box>
              <Typography fontWeight={600} sx={{ mb: 1 }}>
                Date
              </Typography>
              <TextField
                type="date"
                value={roundDate}
                onChange={(e) => setRoundDate(e.target.value)}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  }
                }}
              />
            </Box>
          </Grid>

          {/* 🕐 TIME PICKER */}
          <Grid item xs={12} md={6} size={3}>
            <Box>
              <Typography fontWeight={600} sx={{ mb: 1 }}>
                Time
              </Typography>
              <TextField
                type="time"
                value={roundTime}
                onChange={(e) => setRoundTime(e.target.value)}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  }
                }}
              />
            </Box>
          </Grid>
          
        </Grid>

        {/* 🟢 MAIN AUTOCOMPLETE TEXT AREA */}
        <Box sx={{ mt: 3 }}>
          <Typography fontWeight={600} sx={{ mb: 1 }}>
            Notes
          </Typography>
         <Autocomplete
            freeSolo
            disableClearable
            options={suggestionsData[dialogOpen.field] || []}
            filterOptions={(options, { inputValue }) => {
              const parts = inputValue.split(/[.,]/);
              const last = parts[parts.length - 1].trim().toLowerCase();
              return options.filter((opt) => opt.toLowerCase().includes(last));
            }}
            inputValue={dialogText}

            onInputChange={(event, newValue, reason) => {
              if (reason === "input") {
                setDialogText(newValue);
              }
            }}

            onChange={(event, newValue, reason) => {
              if (newValue && reason === "selectOption") {
                const parts = dialogText.split(/[.,]/);
                parts[parts.length - 1] = ` ${newValue}`;
                setDialogText(parts.join(", "));
              }
            }}
            
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                multiline
                rows={10}
                placeholder={`Enter more details for ${dialogOpen.field}...`}
                inputProps={{
                  ...params.inputProps,
                  spellCheck: true,
                  autoCapitalize: "sentences",
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2
                  }
                }}
              />
            )}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2.5 }}>
        <Button 
          onClick={handleDialogClose}
          sx={{
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600
          }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
            onClick={() => {
            if (!validateRoundEntry()) return;
            handleDialogSave();
          }}
          sx={{
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            px: 3,
            background: "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
            boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
            "&:hover": {
              boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)",
              transform: "translateY(-1px)"
            },
            transition: "all 0.3s ease"
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>

    <VitalsHistoryDialogAdmission
      open={VitalsHistoryOpen}
      onClose={() => setVitalsHistoryOpen(false)}
      patientData={patient}
      startDate={startDate}
    />

    <LabHistoryDialogAdmission
    open={labHistoryOpen}
    onClose={() => setlabHistoryOpen(false)}
    patientData={patient}
    sendstartDate={startDate}
  />

  
  <ScanHistoryDialogAdmission
    open={ScanHistoryOpen}
    onClose={() => setScanHistoryOpen(false)}
    patientData={patient}
    sendstartDate={startDate}
  />

  
    <MedicalHistoryDialogAdmission
      open={openmedHis}
      onClose={() => setopenmedHis(false)}
      id={patient ? patient.id: ''}
      sendstartDate={startDate}
    />

    <RequsetLabDialog
    open={labOpen}
    onClose={() => setLabOpen(false)}
    patient={patient}
    sendstartDate={startDate}

    
/>

<RequestScanDialog
  open={scanOpen}
  onClose={() => setScanOpen(false)}
  patient={patient}
  sendstartDate={startDate}
/>

<MedicationRequestDialog
  open={medDialogOpen}
  onClose={() => setMedDialogOpen(false)}
  patient={patient}
  currentUser={currentUser}
  sendstartDate={startDate}
/>

<RequestOtherServiceDialog
  open={serviceDialogOpen}
  onClose={() => setServiceDialogOpen(false)}
  patient={patient}
  sendstartDate={startDate}
/>

<NurseNotesDialog
  open={nurseNotesOpen}
  onClose={() => setNurseNotesOpen(false)}
  patient={{
    id:        patient?.id,
    fullName:  patient?.name,
    age:       patient?.age,
    gender:    patient?.gender,
    visitDate: startDate,
  }}
/>

<MedicationAdministrationSheet
  open={medSheetOpen}
  onClose={() => setMedSheetOpen(false)}
  patient={{
    id:        patient?.id,
    fullName:  patient?.name,
    age:       patient?.age,
    gender:    patient?.gender,
    visitDate: startDate,
  }}
/>


    </>
      );
    };

export default WardRoundsDialog;